import "./MenuBar.css";
import React, { useContext, useEffect, useRef, useState } from "react";
import { TbMessageCheck } from "react-icons/tb";
import { IoClose } from "react-icons/io5";
import { RiProfileLine } from "react-icons/ri";
import { FaNetworkWired } from "react-icons/fa";
import { FiInfo } from "react-icons/fi";

export default function MenuBar({ isMenuBarOpen, setIsMenuBarOpen }) {
  const menubarContainer = useRef();
  useEffect(() => {
    if (isMenuBarOpen === "true") {
      menubarContainer?.current?.classList?.remove("outMenu");
      menubarContainer?.current?.classList?.add("inMenu");
    } else if (isMenuBarOpen === "false") {
      menubarContainer?.current?.classList?.remove("inMenu");
      menubarContainer?.current?.classList?.add("outMenu");
      setTimeout(() => {
        setIsMenuBarOpen("");
      }, 500);
    } else {
    }
  }, [isMenuBarOpen]);
  const SOCIAL_MEDIA = [
    {
      id: 1,
      svg: (
        <svg
          width="83"
          height="83"
          viewBox="0 0 83 83"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.415 0.107422H60.585C72.9025 0.107422 83 10.2049 83 22.5224V60.5492C83 72.7951 72.9025 82.8926 60.585 82.8926H22.415C10.0975 82.8926 0 72.7951 0 60.5492V22.5224C0 10.2049 10.0975 0.107422 22.415 0.107422ZM41.3926 18.9418H41.6074C53.8533 18.9418 64.1657 29.2541 64.1657 41.5C64.1657 53.9607 53.8533 64.0582 41.6074 64.0582H41.3926C29.1467 64.0582 19.0492 53.9607 19.0492 41.5C19.0492 29.2541 29.1467 18.9418 41.3926 18.9418ZM63.8076 14.5733C66.3141 14.5733 68.5341 16.7934 68.5341 19.2998C68.5341 21.9495 66.3141 24.0979 63.8076 24.0979C61.0147 24.0979 59.0095 21.9495 59.0095 19.2998C59.0095 16.7934 61.0147 14.5733 63.8076 14.5733Z"
            fill="white"
          />
        </svg>
      ),
      link: "https://instagram.com/scarpin.ir?igshid=YmMyMTA2M2Y",
    },
    {
      id: 2,
      svg: (
        <svg
          width="78"
          height="65"
          viewBox="0 0 78 65"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.79663 28.5907C22.4283 21.1898 43.9055 10.5963 62.4078 3.41301C79.6041 -2.75443 79.2413 -1.08559 76.7743 16.0381C74.6701 29.7516 72.4208 43.4651 70.099 57.106C69.3008 63.7088 65.8906 67.1191 58.7073 63.1284L36.5045 47.4558C33.312 44.9163 34.1827 42.8846 36.7222 40.3451L57.2562 20.8995C62.698 15.5302 60.1585 13.426 53.9185 17.7795L25.6208 36.8623C21.5576 39.6921 17.3492 39.6921 12.778 38.3135L3.05524 34.9032C-3.25732 32.5814 1.67663 29.9693 4.79663 28.5907Z"
            fill="white"
          />
        </svg>
      ),
      link: "https://t.me/scarpinChannel",
    },
    {
      id: 3,
      svg: (
        <svg
          width="105"
          height="104"
          viewBox="0 0 105 104"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M104.921 42.1187C99.392 45.8383 95.4712 49.7088 90.8468 54.6349C84.6641 61.2197 78.4311 67.3018 75.2644 69.8151C68.5287 75.2438 62.2455 78.3603 55.912 79.4662C52.5945 80.0694 47.1155 79.818 43.8985 79.0138C41.0836 78.2598 41.2847 78.109 40.1788 81.4265C39.274 83.9901 38.7211 86.7547 38.52 89.4691L38.3692 91.5802L37.565 91.4294C31.2315 90.1728 24.9483 84.7441 22.5355 78.4106C21.7313 76.4 21.2789 74.2385 21.1783 72.0771L21.1281 70.3178L19.5196 68.8601C16.1517 65.7436 13.94 62.0239 13.2866 58.1032C12.1807 51.8702 15.0459 44.833 21.2789 38.5498C27.8637 31.8644 37.6153 26.6368 47.0652 24.5759C50.4833 23.8722 56.5655 23.6711 59.5814 24.1738C65.5128 25.2293 70.3886 28.2453 73.3543 32.719C74.3093 34.1767 74.3596 34.3777 74.259 35.6344C74.259 36.5894 73.9072 37.4942 73.304 38.1979C70.9415 41.616 63.7032 45.1849 55.9623 46.8939C42.29 49.9601 33.594 46.1902 35.0014 37.7958C35.102 36.9413 35.2025 36.1873 35.1522 36.1873C34.9512 35.9862 33.594 36.69 32.1363 37.7455C29.623 39.4546 27.4113 42.8727 26.6573 46.0394C26.4562 46.8939 26.406 48.1506 26.5065 49.4575C26.607 51.1665 26.7578 51.82 27.5118 53.2777C27.9642 54.2327 28.9193 55.6402 29.623 56.3439L30.8796 57.6508L30.377 58.3043C28.9193 60.2144 27.7129 62.3758 26.8584 64.6378C26.2552 66.4976 25.9536 68.458 25.9536 70.4183C25.9536 71.675 26.0541 72.8814 26.3054 74.0375C26.8081 76.4502 28.4669 79.7678 30.1256 81.7281C31.3823 83.1858 34.2977 85.6991 34.7501 85.6991C34.9009 85.6991 35.0014 85.4478 35.0014 85.1462C35.0014 83.9398 35.9565 80.0694 36.7105 78.2095C38.9222 72.7808 43.6974 68.0558 51.3378 63.9843C52.6447 63.3308 56.3141 61.5213 59.5312 60.0636C66.6186 56.746 70.4891 54.7354 72.6003 53.2274C78.7327 48.9046 82.5026 42.5208 83.7593 34.3777C84.2117 31.412 84.2117 25.8828 83.7593 22.8669C81.8492 10.1999 72.3489 1.55414 58.6766 0.146697C43.4461 -1.46181 24.0435 10.3004 12.1305 28.3961C6.34991 37.1926 2.37891 46.9442 0.720136 56.6958C0.116946 60.516 -0.134383 67.5532 0.267744 71.0718C1.27306 79.9186 4.54034 87.0563 10.1701 92.6861C12.9347 95.501 16.2523 97.8635 19.8714 99.5222C32.2368 105.353 45.8588 105.504 57.8724 99.9244C63.0498 97.4613 68.1769 93.6411 73.6056 88.1622C78.8835 82.834 82.5026 78.3603 92.3045 64.9896C95.2199 60.9683 100.598 53.4285 104.871 50.9152L104.921 42.1187Z"
            fill="white"
          />
        </svg>
      ),
      link: "https://eitaa.com/ScarpinChannel",
    },
  ];

  return (
    <>
      <div
        className={`absolute  w-[100vw] h-screen z-[1000] backdrop-blur-sm ${
          isMenuBarOpen === "true" ? "block" : "hidden"
        }`}
      ></div>

      <div
        dir="rtl"
        ref={menubarContainer}
        className={`fixed w-[80%] h-full top-0 -right-[100vw] flex flex-col items-center justify-between bg-color-primary-B py-[5.5vw]   rounded-[2px] z-[1000]  ${
          isMenuBarOpen === "true" ? "block" : ""
        }`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="w-full h-full flex flex-col items-center justify-between">
          <div className="w-full flex flex-col items-center justify-start">
            <div className="w-full flex items-center justify-between mb-[4vw] px-[5.5vw]">
              <div className="w-[20vw] ">
                <svg
                  width="20vw"
                  viewBox="0 0 239 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M191.805 47.6372V14.5252C191.805 13.6523 192.213 12.8958 192.969 12.4884C193.726 12.0229 194.598 12.0229 195.355 12.4884C196.053 12.8958 196.519 13.6523 196.519 14.5252V47.6372C196.519 48.2773 196.286 48.8593 195.821 49.3248C195.413 49.7322 194.773 49.9649 194.133 49.9649C192.853 49.9649 191.805 48.9175 191.805 47.6372Z"
                    fill="#F8F8F3"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M178.77 12.1393H153.921C153.048 12.1393 152.292 12.6048 151.885 13.3031C151.477 14.0597 151.477 14.9326 151.885 15.6891C152.292 16.4456 153.048 16.9111 153.921 16.9111H176.384C178.537 16.9111 180.458 18.0168 181.505 19.8208C182.552 21.683 182.552 23.8943 181.505 25.7565C180.458 27.5605 178.537 28.7244 176.384 28.7244H155.143C154.212 28.7244 153.281 29.0735 152.583 29.7719C151.943 30.412 151.535 31.2849 151.535 32.2742V46.4733C151.535 47.4044 151.943 48.2773 152.583 48.9757C153.281 49.6158 154.212 49.9649 155.143 49.9649H159.857C160.788 49.9649 161.661 49.6158 162.359 48.9757C163 48.2773 163.407 47.4044 163.407 46.4733V39.3738C163.407 38.6754 163.931 38.1517 164.571 38.1517H178.77C184.647 38.1517 189.419 33.438 189.419 27.5023V22.7887C189.419 16.9111 184.647 12.1393 178.77 12.1393Z"
                    fill="#F8F8F3"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M136.172 12.1393H111.324C110.509 12.1393 109.694 12.6048 109.287 13.3031C108.88 14.0597 108.88 14.9326 109.287 15.6891C109.694 16.4456 110.509 16.9111 111.324 16.9111H133.786C135.94 16.9111 137.86 18.0168 138.907 19.8208C140.013 21.683 140.013 23.8943 138.907 25.7565C137.86 27.5605 135.94 28.7244 133.786 28.7244H119.064C117.609 28.7244 116.328 29.5391 115.747 30.8775C115.223 32.216 115.514 33.729 116.561 34.7765L129.771 47.9864C129.888 48.1028 130.004 48.2191 130.12 48.3355C130.237 48.4519 130.411 48.5101 130.528 48.6265C130.702 48.7429 130.935 48.8593 131.11 48.9757C131.401 49.1502 131.692 49.3248 132.041 49.4412C132.332 49.5576 132.681 49.674 132.972 49.7904C133.205 49.8486 133.379 49.9067 133.612 49.9067C133.786 49.9067 133.961 49.9649 134.136 49.9649C134.31 49.9649 134.485 49.9649 134.659 49.9649H143.272C143.388 49.9649 143.447 49.9649 143.563 49.9649C143.679 49.9649 143.738 49.9649 143.854 49.9649C143.97 49.9067 144.028 49.9067 144.145 49.9067C144.261 49.8486 144.319 49.8486 144.436 49.7904C144.494 49.7904 144.61 49.7322 144.669 49.674C144.785 49.6158 144.843 49.5576 144.96 49.4994C144.96 49.4994 145.018 49.4412 145.076 49.383C145.076 49.383 145.134 49.383 145.134 49.3248C145.251 49.2084 145.309 49.1502 145.367 49.0339C145.425 48.9757 145.483 48.8593 145.542 48.8011C145.542 48.6847 145.6 48.5683 145.6 48.4519C145.658 48.3355 145.658 48.2191 145.658 48.161C145.658 48.1028 145.658 48.0446 145.658 47.9864C145.658 47.9282 145.658 47.87 145.658 47.8118C145.6 47.6954 145.6 47.6372 145.6 47.5208C145.542 47.4626 145.542 47.3462 145.483 47.2299C145.425 47.1717 145.425 47.1135 145.367 46.9971C145.309 46.9389 145.251 46.8225 145.192 46.7061C145.134 46.6479 145.076 46.5897 145.018 46.5315C144.96 46.4733 144.901 46.357 144.785 46.2988L138.326 39.7811C138.035 39.4901 137.918 39.0828 138.035 38.6754C138.151 38.2681 138.442 37.9771 138.849 37.8607C143.563 36.6387 146.822 32.3906 146.822 27.5023V22.7887C146.822 16.9111 142.05 12.1393 136.172 12.1393Z"
                    fill="#153038"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M77.7463 12.1393H50.861C48.0095 12.1393 45.3326 13.245 43.2958 15.2817C41.3173 17.2603 40.2116 19.9372 40.2116 22.7887V39.3738C40.2116 42.167 41.3173 44.9021 43.2958 46.8807C45.3326 48.8593 48.0095 49.9649 50.861 49.9649H62.6742C65.5257 49.9649 68.2026 48.8593 70.2393 46.8807L95.4952 21.6248H95.9608C97.532 21.6248 99.045 22.2067 100.151 23.3124C101.256 24.4181 101.897 25.9893 101.897 27.5023V32.8561H95.8444C94.6223 32.8561 93.4585 33.4962 92.8184 34.6019C92.1782 35.7076 92.1782 37.046 92.8184 38.1517C93.4585 39.2574 94.6223 39.9557 95.8444 39.9557H101.897V46.4733C101.897 48.3937 103.468 49.9649 105.446 49.9649C107.367 49.9649 108.996 48.3937 108.996 46.4733V22.7887C108.996 19.9372 107.832 17.2603 105.854 15.2817C103.875 13.245 101.14 12.1393 98.3467 12.1393H91.6545C89.4431 12.1393 87.3482 13.0122 85.777 14.5834L62.2669 38.0935C60.6956 39.6647 58.6007 40.5376 56.3893 40.5376H53.2469C49.9299 40.5376 47.3112 37.9189 47.3112 34.6019V22.7887C47.3112 19.5298 49.9299 16.9111 53.2469 16.9111H77.7463C79.0847 16.9111 80.1322 15.8055 80.1322 14.5252C80.1322 13.1868 79.0847 12.1393 77.7463 12.1393Z"
                    fill="#153038"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.6525 32.2742H8.26345C6.1103 32.2742 3.95715 31.4013 2.44412 29.8301C0.8729 28.317 0 26.1639 0 23.9525V22.7887C0 19.9372 1.10567 17.2603 3.14244 15.2817C5.12101 13.245 7.8561 12.1393 10.6494 12.1393H35.4979C36.3126 12.1393 37.1273 12.6048 37.5347 13.3031C38.0002 14.0597 38.0002 14.9326 37.5347 15.6891C37.1273 16.4456 36.3126 16.9111 35.4979 16.9111H11.2313C9.77648 16.9111 8.37984 17.6676 7.62333 18.9479C6.92501 20.2282 6.92501 21.7994 7.62333 23.0796C8.37984 24.3599 9.77648 25.1746 11.2313 25.1746H29.5622C31.7736 25.1746 33.8685 26.0475 35.4397 27.5605C36.9528 29.1317 37.8839 31.2267 37.8839 33.438V39.3738C37.8839 42.167 36.72 44.9021 34.7414 46.8807C32.7628 48.8593 30.0278 49.9649 27.2345 49.9649H4.71366C3.4916 49.9649 2.26954 49.4994 1.39664 48.6265C0.52374 47.6954 0 46.5315 0 45.2513C0 42.6326 2.15315 40.5376 4.71366 40.5376H26.6525C28.9221 40.5376 30.7261 38.6754 30.7261 36.4059C30.7261 34.0782 28.9221 32.2742 26.6525 32.2742Z"
                    fill="#153038"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M239 41.4105C239 46.1242 235.101 49.9649 230.387 49.9649H226.721C224.452 49.9649 222.473 48.7429 221.309 46.7643L208.914 25.4656C208.565 24.8836 207.867 24.5345 207.168 24.709C206.47 24.8836 206.004 25.4656 206.004 26.1639V46.4733C206.004 48.3937 204.433 49.9649 202.455 49.9649C201.523 49.9649 200.651 49.6158 200.01 48.9757C199.312 48.2773 198.963 47.4044 198.963 46.4733V20.7519C198.963 18.4824 199.836 16.271 201.465 14.6998C203.095 13.0704 205.248 12.1393 207.517 12.1393H211.242C213.453 12.1393 215.432 13.4195 216.596 15.3399L229.049 36.6969C229.34 37.2788 230.038 37.628 230.737 37.4534C231.435 37.2788 231.9 36.6969 231.9 35.9404V15.6891C231.9 14.758 232.308 13.8269 232.948 13.1868C233.588 12.4884 234.519 12.1393 235.45 12.1393C237.371 12.1393 239 13.7105 239 15.6891V41.4105Z"
                    fill="#F8F8F3"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M193.551 44.4947V10.1025H193.26H188.255C188.314 8.64765 188.954 7.3092 189.943 6.26172L190.059 6.20353V1.72264H188.488V0.0350342H199.72V1.72264H198.148V6.14533L198.265 6.26172C199.312 7.25101 199.952 8.64765 200.069 10.1025H195.006H194.715V44.4947C194.715 45.2513 194.657 45.8914 194.54 46.4151C194.424 46.8807 194.308 47.1716 194.133 47.1716C193.842 47.1716 193.551 45.9496 193.551 44.4947Z"
                    fill="#153038"
                  />
                </svg>
              </div>

              <IoClose
                className="w-[4vw] h-[4vw]"
                onClick={() => {
                  setIsMenuBarOpen("false");
                }}
              />
            </div>
            <div className="w-full gap-y-[2vw] flex flex-col items-center justify-start overflow-y-auto px-[5.5vw] mt-[12px]">
              {window.location.pathname !== "/46464" && (
                <div
                  className={`w-full flex items-center justify-between text-[3.5vw] text-[#000000] font-font_primary_A z-[1000] font-normal pr-[1vw] border-b-[1px] border-[#b69a20] pb-[2vw] `}
                  onClick={() => {
                    if (window.location.pathname === "/") {
                      setIsMenuBarOpen("false");
                    } else {
                      window.location.href = "/";
                    }
                  }}
                >
                  <div className="w-full flex items-center justify-start gap-x-2">
                    <RiProfileLine
                      className="w-[4vw] h-[4vw]"
                      color="#153038"
                    />
                    <p>صفحه اصلی</p>
                  </div>
                </div>
              )}
              {window.location.pathname !== "/4654646" && (
                <div
                  className={`w-full flex items-center justify-between text-[3.5vw] text-[#000000] font-font_primary_A z-[1000] font-normal pr-[1vw] border-b-[1px] border-[#b69a20] pb-[2vw]`}
                  onClick={() => {
                    if (window.location.pathname === "/workWidthUs") {
                      setIsMenuBarOpen("false");
                    } else {
                      window.location.href = "/workWidthUs";
                    }
                  }}
                >
                  <div className="w-full flex items-center justify-start gap-x-2">
                    <FaNetworkWired
                      className="w-[4vw] h-[4vw]"
                      color="#153038"
                    />
                    <p>همکاری با ما</p>
                  </div>
                </div>
              )}
              {window.location.pathname !== "/4654646" && (
                <div
                  className={`w-full flex items-center justify-between text-[3.5vw] text-[#000000] font-font_primary_A z-[1000] font-normal pr-[1vw] border-b-[1px] border-[#b69a20] pb-[2vw]`}
                  onClick={() => {
                    if (window.location.pathname === "/contactUs") {
                      setIsMenuBarOpen("false");
                    } else {
                      window.location.href = "/contactUs";
                    }
                  }}
                >
                  <div className="w-full flex items-center justify-start gap-x-2">
                    <TbMessageCheck
                      className="w-[4vw] h-[4vw]"
                      color="#153038"
                    />
                    <p>تماس با ما</p>
                  </div>
                </div>
              )}
              {window.location.pathname !== "/4654646" && (
                <div
                  className={`w-full flex items-center justify-between text-[3.5vw] text-[#000000] font-font_primary_A z-[1000] font-normal pr-[1vw] border-b-[1px] border-[#b69a20] pb-[2vw]`}
                  onClick={() => {
                    if (window.location.pathname === "/aboutUs") {
                      setIsMenuBarOpen("false");
                    } else {
                      window.location.href = "/aboutUs";
                    }
                  }}
                >
                  <div className="w-full flex items-center justify-start gap-x-2">
                    <FiInfo className="w-[4vw] h-[4vw]" color="#153038" />
                    <p>درباره ما</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="w-full flex flex-col items-center justify-between px-[5.5vw] pb-[40px]">
            <div className="w-full flex items-center justify-between text-[4vw] text-[#000000] font-font_primary_A z-[1000] ">
              <div
                className="relative border-[1px] rounded-[1.8vw] border-[#474747] w-full h-[15vw] flex items-center justify-between px-[4vw]"
                onClick={() => {
                  window.location.href = "/links/app";
                }}
              >
                <span className=" font-font_primary_A text-[3vw] ">
                  دانلود نسخه مالک خودرو
                </span>

                <img
                  src="/../assets/images/other/icon_driver.svg"
                  alt=""
                  className="w-[8vw]"
                />
              </div>
            </div>
            <div className="w-full flex items-center justify-between text-[4vw] text-[#000000] font-font_primary_A z-[1000] mt-[10px]">
              <div
                className="relative border-[1px] rounded-[1.8vw] border-[#474747] w-full h-[15vw] flex items-center justify-between px-[4vw]"
                onClick={() => {
                  window.location.href = "/repair/links/app";
                }}
              >
                <span className=" font-font_primary_A text-[3vw] ">
                  دانلود نسخه اتوسرویس
                </span>

                <img
                  src="/../assets/images/other/icon_repair.svg"
                  alt=""
                  className="w-[10vw]"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex items-center justify-between px-[4.5vw]  ">
          <div className="flex items-center justify-center gap-x-[4px] font-font_primary_A font-semibold text-[12px]">
            <img
              src="/../assets/images/other/icon_social.svg"
              className="w-[15px] h-[15px]"
            />
            <span>شبکه های اجتماعی</span>
          </div>
          <div className="flex items-center justify-center gap-x-[2vw]">
            {SOCIAL_MEDIA.map((social) => (
              <a
                key={social.id}
                href={social.link}
                target="_blank"
                className=""
              >
                <div className="w-[28px] h-[28px] flex items-center justify-center bg-color-primary-D rounded-[6px] p-[6px]">
                  {social.svg}
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
